<template>
  <changerouter-part></changerouter-part>
  <navigation-part></navigation-part>

  <router-view v-slot="{ Component }">
    <transition name="page" mode="out-in" @before-leave="beforeEnter">
      <component :is="Component" />
    </transition>
  </router-view>

  <footer-part></footer-part>
</template>

<script>
import navigationPart from "./Component/Page/Nav.vue";
import footer from "./Component/Footer.vue";

export default {
  components: {
    navigationPart,
    footerPart: footer,
  },
  methods: {
    beforeEnter() {
      let background = document.querySelector(".change-router");
      background.classList.add("active");
      background.addEventListener("animationend", () => {
        background.classList.remove("active");
      });
    },
  },
};
</script>

<style lang="sass">
@import "../public/Sass/index.scss"
</style>
